export const GRID = "grid";

export const STRETCH = "stretch";
export const CENTER = "center";
export const SPACE_BETWEEN = "space-between";

export const FR = "1fr";
export const AUTO_FIT = "auto-fit";
export const AUTO = "auto";
export const DEFAULT_GAP = "1em";

export const ROW = "row";
export const COLUMN = "column";
export const DISPLAY_FLEX = "flex";
